"use client";
import React, { useEffect, useState } from "react";
import { ProductCard } from "..";
import { ContentLoader } from "../loaders";
import { ContextProps, useGlobalContext } from "@/contexts/AppContext";
import { DrinkTypeProps, ProductProps } from "@/interface";
import { useFetchProducts } from "@/hooks";
import styles from "./RelatedProducts.module.scss";
import { useSelector } from "react-redux";
import { AppState } from "@/store/configureStore";
import useFetchFavorites from "@/hooks/products/useFetchFavorites";

const RelatedProducts = ({ type }: DrinkTypeProps) => {
	const { drinkType }: ContextProps = useGlobalContext();
	const { activeProduct } = useSelector((state: AppState) => state.products);
	const [productList, setProductList] = useState([]);
	const { fetchSimilar } = useFetchFavorites();
	useEffect(() => {
		fetchSimilar(activeProduct?.category?.name, setProductList);
	}, [activeProduct]);
	return (
		<div className={styles.hero_container}>
			{productList &&
				productList.length > 0 &&
				productList
					.slice(0, 4)
					.map((product: ProductProps, index: number) => (
						<ProductCard key={index} {...product} />
					))}
		</div>
	);
};

export default RelatedProducts;
